import loginService from '../../services/login'
import loginStorage from '../../storage/login'

const state = {
    token: null,
    restaurantOwnerId: null,
    restaurantOwnerName: null,
    phoneNumber: null
}
// getters
const getters = {

}
// actions
const actions = {
    async authenticateAction(context, credentials) {
        await loginService.authenticate(credentials)
                    .then(response => {
                        context.commit('setProfileState', response);
                        loginStorage.storeToken(response.token);
                        loginStorage.storeRestaurantOwnerId(response.restaurantOwnerId);
                        loginStorage.storeRestaurantOwnerName(response.restaurantOwnerName);
                        loginStorage.storePhoneNumber(response.phoneNumber);
                    });
    },
    async loadProfileFromStorageAction(context) {
        let profile = {};
        profile.token = loginStorage.getToken();
        profile.restaurantOwnerId = loginStorage.getRestaurantOwnerId();
        profile.restaurantOwnerName = loginStorage.getRestaurantOwnerName();
        profile.phoneNumber = loginStorage.getPhoneNumber();
        await context.commit('setProfileState', profile);
    }
}

// mutations
const mutations = {
    setProfileState(state, profile) {
        state.token = profile.token;
        state.restaurantOwnerId = profile.restaurantOwnerId;
        state.restaurantOwnerName = profile.restaurantOwnerName;
        state.phoneNumber = profile.phoneNumber;
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}